
	import { defineComponent } from 'vue';

	export default defineComponent({
		name: "single-error-message",
		props: {
			errorMessage: String,
		},
	});
